// Nov 3 2026 · Karine: Black Friday teaser poster — in the home rotation box, lobby TV,
// My Account and the skin-tips email. Auto-removes itself on Nov 28 2026 (Ottawa time).
export const BLACK_FRIDAY_TEASER_IMG = "/posters/black-friday-teaser-2026.jpg";
export const BLACK_FRIDAY_TEASER_END = "2026-11-28"; // first day it is NOT shown

export function isBlackFridayTeaserActive(now = new Date()) {
  const ottawaDay = new Intl.DateTimeFormat("en-CA", { timeZone: "America/Toronto", year: "numeric", month: "2-digit", day: "2-digit" }).format(now);
  return ottawaDay < BLACK_FRIDAY_TEASER_END;
}
